import React from 'react';

export default () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.58685 10.5164L11.8967 4.20657L10.9108 3.18779L5.58685 8.51174L3.0892 6.01408L2.10329 7L5.58685 10.5164ZM2.03756 2.07042C3.41784 0.690141 5.07199 0 7 0C8.92801 0 10.5712 0.690141 11.9296 2.07042C13.3099 3.42879 14 5.07199 14 7C14 8.92801 13.3099 10.5822 11.9296 11.9624C10.5712 13.3208 8.92801 14 7 14C5.07199 14 3.41784 13.3208 2.03756 11.9624C0.679186 10.5822 0 8.92801 0 7C0 5.07199 0.679186 3.42879 2.03756 2.07042Z" fill="currentColor" />
  </svg>
);
